<div class="table-container">
    <p-table [value]="sales" [responsive]="true" responsiveLayout="scroll" styleClass="sales-widget-table" [loading]="loading">
        <ng-template pTemplate="header">
            <tr>
                <th *ngFor="let col of salesHeaders">{{ col.header }}</th>
                <th></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-sale>
            <tr (dblclick)="saleClicked(sale)">
                <td>{{ sale.FechaFactura | date:'shortDate' }}</td>
                <td>{{ sale.SerieFactura }}</td>
                <td>{{ sale.NumeroFactura }}</td>
                <td>{{ sale.BaseImponible}}</td>
                <td>{{ sale.TotalIva }}</td>
                <td>{{ sale.ImporteFactura }}</td>
                <td (click)="saleClicked(sale)" style="cursor: pointer;">
                    <i class="pi pi-eye"></i>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="7">{{'general.not_data' | translate }}</td>
            </tr>
        </ng-template>
    </p-table>
</div>